import {
  GET_ANETA_PACKS,
  GET_CURRENT_ANETA_PACK,
  CHANGE_AP_OPTIONS,
  SET_ANETAPACK_ERROR,
} from 'actions/actionTypes';
import {
  IAnetaPackState,
  IAnetaPacks,
  ICurrentAnetaPack,
  AnetapackOptions,
} from 'types';

type ActionType =
  | { type: 'GET_ANETA_PACKS'; payload: IAnetaPacks[] }
  | { type: 'GET_CURRENT_ANETA_PACK'; payload: ICurrentAnetaPack }
  | {
      type: 'CHANGE_AP_OPTIONS';
      payload: AnetapackOptions;
    }
  | { type: 'SET_ANETAPACK_ERROR'; payload: string[] };

const initialState: IAnetaPackState = {
  anetaPacks: [],
  errors: [],
  currentAnetaPack: undefined,
  anetapackOptions: { homeroom: true, schedule: true },
};

const anetaPack = (
  state = initialState,
  action: ActionType
): IAnetaPackState => {
  switch (action.type) {
    case GET_ANETA_PACKS:
      return {
        ...state,
        anetaPacks: action.payload,
      };
    case GET_CURRENT_ANETA_PACK:
      return {
        ...state,
        currentAnetaPack: action.payload,
      };
    case CHANGE_AP_OPTIONS:
      return {
        ...state,
        anetapackOptions: action.payload,
      };
    case SET_ANETAPACK_ERROR:
      return {
        ...state,
        errors: action.payload,
      };
    default:
      return state;
  }
};

export default anetaPack;
